import { Navigate, useParams } from "react-router";
import { ChatRoutes, chatPath } from "@/constants/routes";

/**
 * Links antigos do chat v1 (`/chat/:id`): leva para o v2 com a mesma conversa
 * aberta, em vez de cair na lista vazia.
 */
export const LegacyChatRedirect = () => {
  const { id } = useParams();
  return <Navigate to={id ? chatPath(id) : ChatRoutes.CHAT} replace />;
};
